module.exports = __webpack_public_path__ + "img/8.2aa87665.jpg";